/**
 * Access-list reloads asked for by GRANTED/REVOKED_PERMISSION signals (plan access-refetch row 7).
 *
 * Every open tab of the org receives those signals and each reload is the org's whole access list,
 * so a hidden tab defers its reload until it is visible again, then reloads once however many
 * signals it missed. Coalescing between visible requests is the saga's job (Redux/access/accessRefresh.js).
 *
 * @param {Object} p
 * @param {() => void} p.refresh - dispatches the access refresh
 * @param {() => boolean} [p.isHidden] - true while the tab is hidden; defaults to document.hidden
 * @returns {{ onSignal: () => void, onVisibilityChange: () => void, cancel: () => void }}
 */
export function createAccessRefreshGate({
	refresh,
	isHidden = () => typeof document !== 'undefined' && document.hidden
}) {
	let pendingWhileHidden = false;

	return {
		onSignal: () => {
			if (isHidden()) {
				pendingWhileHidden = true;
				return;
			}
			refresh();
		},
		onVisibilityChange: () => {
			if (!isHidden() && pendingWhileHidden) {
				pendingWhileHidden = false;
				refresh();
			}
		},
		cancel: () => {
			pendingWhileHidden = false;
		}
	};
}
